module.exports = __webpack_public_path__ + "img/cloud-folder.232ce5db.png";